import 'swiper/css';
import 'swiper/css/bundle'
import { useRef, useState } from "react";
import { Box, Grid, IconButton, Paper, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useNavigate } from "react-router";
import LetMeHoldThatForYou from '../../images/demo-pics/let_me_hold_that_for_you.avif'
import TakeItFromTheTop from '../../images/demo-pics/take_it_from_the_top.avif'
import BigDipper from '../../images/demo-pics/big_dipper.avif'
import WrapItUp from '../../images/demo-pics/wrap_it_up.avif'
import AllCakedUp from '../../images/demo-pics/all_caked_up.avif'
import Adorable from '../../images/demo-pics/adorable.avif'
import MichaelBuble from '../../images/demo-pics/michael_buble.avif'
import Inspiration from '../../images/demo-pics/inspiration.avif'
// import BannerMP4 from '../../images/GyrosaBannerVideo.mp4'
import BannerWEBM from '../../images/GyrosaBannerVideo.webm'
import { ReactComponent as FacebookIcon } from '../../SVG/2021_Facebook_icon.svg';
import { ReactComponent as InstagramIcon } from '../../SVG/Instagram_Glyph_Gradient_RGB_logo.svg';
import {Swiper, SwiperSlide} from "swiper/react";
import { Pagination, Autoplay, Navigation, EffectFade } from 'swiper/modules';
import StyledButton from "../../components/reusable/StyledButton";
import PauseIcon from '@mui/icons-material/Pause'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import StuccoTexture from '../../images/stucco.avif';
import StyledSvgIcon from '../../components/reusable/StyledSvgIcon';

const useStyles = makeStyles()((theme) => ({
  phrasesContainer: {
    display: 'flex', 
    // backgroundColor: 'white', 
    backgroundImage: `url(${StuccoTexture})`,
    backgroundSize: '50%',
    backgroundPosition: 'center',
    backgroundRepeat: 'repeat',
    paddingTop: 10,
    paddingBottom: 10,
    borderTop: '2px solid', 
    borderBottom: '2px solid', 
    borderColor: theme.palette.primary.main
  },
  phrasesText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white', 
    width: '100%', 
    textAlign: 'center', 
    backgroundColor: theme.palette.primary.main, 

    padding: 8
  },
  swiperPaper: {
    display: 'flex',
    maxHeight: 'calc(100vh - 100px)', 
    overflow: 'hidden', 
    borderRadius: '0px',
    alignItems: 'center',
    justifyContent: 'center'
  }
}))

export default function Home() {
  const navigate = useNavigate();
  const {classes} = useStyles()
  const videoRef = useRef<HTMLVideoElement | null>(null)
  const [playing, setPlaying] = useState(true)

  const togglePlay = () => {
    if (videoRef.current){
      if (videoRef.current.paused) {
        videoRef.current.play()
        setPlaying(true)
      } else {
        videoRef.current.pause()
        setPlaying(false)
      }
    }
  }

  return (
    <>
      {/* Banner Video */}
      <Box sx={{position: 'relative', display: 'flex', alignItems: 'center', maxHeight: {xs: 'calc(100vh - 54px)', md: 'calc(100vh - 64px)', overflow: 'hidden'}}}>
        <Box
          ref={videoRef}
          component="video"
          autoPlay
          muted
          loop
          playsInline
          sx={{
            width: '100vw',
            maxHeight: {xs: 'calc(100vh - 54px)', md: 'calc(100vh - 64px)'},
            objectFit: 'cover',
          }}
        >
          {/* Default source */}
          <source src={BannerWEBM} type="video/webm" />
          {/* Fallback for browsers that don't support webm (because they're garbage) */}
          {/* <source src={BannerMP4} type="video/mp4" /> */}
        </Box>
        <IconButton
          onClick={togglePlay}
          sx={{
            position: 'absolute',
            bottom: 16,
            right: 16,
            bgcolor: 'rgba(0,0,0,0.5)',
            color: 'white',
          }}
        >
          {playing ? <PauseIcon /> : <PlayArrowIcon />}
        </IconButton>
      </Box>

      {/* Beauty shot Header  */}
      <Grid
        container
        spacing={{ xs: 2, md: 8 }}
        sx={[
          (theme) => ({
          padding: { xs: 3, md: 5 },
          // backgroundImage: `linear-gradient(90deg, rgba(53, 144, 255, 0.8), 60%, rgba(96, 165, 250, 0.8), 85%, rgba(96, 165, 250, 0.3))`,
          backgroundColor: 'rgba(53, 144, 255, 0.8)',
          borderTop: `2px solid ${theme.palette.primary.main}`,
          })
        ]}
      >
        
        <Grid size={{sm: 12}} sx={{display: 'flex',justifyContent: 'center'}}>
          <Typography variant="h1" sx={{color: 'white', textAlign: 'center', textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)', textTransform: 'uppercase'}}>
            You eat with your eyes before your mouth.
          </Typography>
        </Grid>
      </Grid>
      
      {/* Beauty Shot container - zero padding */}
      <Grid         
        container
        spacing={{ xs: 2, md: 8 }}
        sx={[
          (theme) => ({
          padding: { xs: 0, md: 5 },
          // backgroundImage: `linear-gradient(90deg, rgba(53, 144, 255, 0.8), 60%, rgba(96, 165, 250, 0.8), 85%, rgba(96, 165, 250, 0.3))`,
          backgroundColor: 'rgba(53, 144, 255, 0.8)',
          })
        ]}
      >
        <Grid size={{xs: 12, md: 6}}>
          <Paper elevation={8} sx={{borderRadius: {xs: '0px', md: '10px'}}}>
            <Box
              component="img"
              src={LetMeHoldThatForYou}
              alt="Gyrosa featured dish"
              sx={{display: 'flex', width: '100%', borderRadius: {xs: '0px', md: '10px'}}}
            />
          </Paper>
        </Grid>
        <Grid size={{xs: 12, md: 6}} sx={{display: 'flex',justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
          <Typography variant="h2" sx={{textAlign: 'center', color: 'white', textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)', padding: {xs: 3, md: '0px'}}}>
            Gyrosa started with a simple idea: serve Greek food the way it was supposed to be enjoyed. Real ingredients, real people. Full plates, full hearts. Fresh Greek. Done quick.
          </Typography>
        </Grid>

      </Grid>

      {/* Phrases Box */}
      <Box className={classes.phrasesContainer}>
        <Typography variant="subtitle1" className={classes.phrasesText}>
          Yamas ● Γεια μας ● Cheers!
        </Typography>
        <Typography variant="subtitle1" className={classes.phrasesText}>
          Kali Orexi ● καλή όρεξη ● Good Appetite!
        </Typography>
        <Typography variant="subtitle1" className={classes.phrasesText}>
          Efharisto Poli ● Ευχαριστώ πολύ ● Thank You Very Much!
        </Typography>
      </Box>

      {/* Lifestyle Shots Carousel */}
      <Grid container spacing={{xs: 0, md: 0}} sx={{padding: {xs: 0, md: 0}, margin: 0}} >
          <Grid size={{xs: 12, md: 12}} sx={{display: 'flex', alignItems: 'center', margin: 'auto'}} >
            <Swiper
              grid={{
                rows: 1
              }}
              style={{
                width: '100%',
                paddingBottom: '30px',
                maxHeight: 'calc(100vh - 100px)',
              }}
              grabCursor={true}
              fadeEffect={{
                crossFade: true
              }}
              // navigation={true}
              slidesPerView={1}
              pagination={{
                dynamicBullets: true,
                dynamicMainBullets: 5
              }}
              loop={true}
              autoplay={{delay: 5000}}
              modules={[Autoplay, Pagination, Navigation, EffectFade]}
            >
              <SwiperSlide >
                <Paper elevation={8} className={classes.swiperPaper} >
                  <img src={BigDipper} style={{ width: '100%'}}/>
                  <div className="swiper-lazy-preloader"></div>
                </Paper>
              </SwiperSlide>
              <SwiperSlide>
                <Paper elevation={8} className={classes.swiperPaper} >
                    <img src={Adorable} style={{width: '100%'}}/>
                    <div className="swiper-lazy-preloader"></div>
                </Paper>
              </SwiperSlide>
              <SwiperSlide>
                <Paper elevation={8} className={classes.swiperPaper} >
                    <img src={AllCakedUp} style={{width: '100%'}}/>
                    <div className="swiper-lazy-preloader"></div>
                </Paper>
              </SwiperSlide>
              <SwiperSlide>
                <Paper elevation={8} className={classes.swiperPaper} >
                    <img src={TakeItFromTheTop} style={{width: '100%'}}/>
                    <div className="swiper-lazy-preloader"></div>
                </Paper>
              </SwiperSlide>
              <SwiperSlide>
                <Paper elevation={8} className={classes.swiperPaper} >
                    <img src={WrapItUp} style={{width: '100%'}}/>
                    <div className="swiper-lazy-preloader"></div>
                </Paper>
              </SwiperSlide>
              <SwiperSlide>
                <Paper elevation={8} className={classes.swiperPaper} >
                    <img src={MichaelBuble} style={{width: '100%'}}/>
                    <div className="swiper-lazy-preloader"></div>
                </Paper>
              </SwiperSlide>
              <SwiperSlide>
                <Paper elevation={8} className={classes.swiperPaper} >
                    <img src={Inspiration} style={{width: '100%'}}/>
                    <div className="swiper-lazy-preloader"></div>
                </Paper>
              </SwiperSlide>
              
            </Swiper>
        </Grid>
      </Grid>

      {/* Socials and CTA */}
      <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', paddingBottom: 4}}>
        <Typography variant="h1" sx={{textAlign: 'center'}}>
          Share your Gyrosa moments with us!
        </Typography>
        <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>

        <Box sx={{marginRight: 2}}>
          <IconButton onClick={() => window.open('https://www.facebook.com/Gyrosagreek/', '_blank')}>
            <StyledSvgIcon               
              component={FacebookIcon} 
              viewBox="0 0 40 40"
              sx={{ fontSize: '72px' }} 
            />
          </IconButton>
        </Box>
        <Box sx={{marginLeft: 2}}>
          <IconButton onClick={() => window.open('https://www.instagram.com/gyrosagreek/?hl=en', '_blank')}>
            <StyledSvgIcon               
              component={InstagramIcon} 
              viewBox="0 0 680 680"
              sx={{ fontSize: '72px'}} 
            />
          </IconButton>
        </Box>
        </Box>
      </Box>
      
      <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', paddingBottom: 8}}>
        <StyledButton 
          onClick={() => navigate('/order')}
          fullWidth={true}
          sx={{width: {xs: '80%', md: '50%'}}}
          variant='contained'
          size="large"
        >
          Order Online
        </StyledButton>
      </Box>
    </>
  )
}